import { useEffect, useState } from 'react';
import styled from 'styled-components';
export const CountdownTimer = ({ initialTime }: { initialTime: string }) => {
  const [minutes, setMinutes] = useState<number>(0);
  const [seconds, setSeconds] = useState<number>(0);

  useEffect(() => {
    // "5분"을 문자열의 포맷으로 변환
    setMinutes(5);
    setSeconds(0);
  }, [initialTime]);

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          if (minutes === 0) {
            clearInterval(timer);
            return 0;
          } else {
            setMinutes((prevMinutes) => prevMinutes - 1);
            return 59;
          }
        } else {
          return prevSeconds - 1;
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [minutes]);

  const formatTime = (value: number): string => {
    return value.toString().padStart(2, '0');
  };
  return (
    <CountText>
      {formatTime(minutes)}:{formatTime(seconds)}
    </CountText>
  );
};

const CountText = styled.span`
  font-size: 12px;
  font-weight: 700;
`;
